import React from "react"
import { Outlet , Navigate  } from "react-router-dom"
import { Layout } from "../common/Layout";

export default function PrivateRoute() {
  const authToken = localStorage.getItem('token');

  return authToken ? <Outlet /> : <Navigate to="/login" />;
}